<template>
    <div id="home">
    	<van-nav-bar
		  	:title="$t('EditTable.title')"
			left-arrow
			fixed
			:z-index=9
		  	@click-left="$router.go(-1)">
		</van-nav-bar>
		<div v-if="activeStore!=0"  class="contentGroup">
			<van-cell-group>
				<!-- <van-cell v-if="queue=='1'||queue=='0'" class="bigCell" :title="$t('ShopSet.autoPrint')" size="large">
					<van-switch :value="queue=='1'" @input="changeQueue" active-color="#2f75f7" inactive-color="#ee0a24" />
				</van-cell> -->
				<div v-for='(item,index) in areaLists'>
					<van-cell :title="item.name" >
						<div class="inputWrap">
							<van-field
								class='inputNum'
							  	readonly
							  	clickable
							  	:value='item.section_left'
							  	@click='actIndex=index;showNum=true;'
						  	/>
						  	<span class="text" v-if='item.section_right'>~</span>
						  	<span v-else class="text">{{$t('EditTable.peopleNum')}}</span>
						  	<van-field
						  		v-if='item.section_right'
								class='inputNum inputEndNum'
							  	readonly
							  	clickable
							  	:value='item.section_right'
							  	@click='actIndex=index;showEndNum=true;'
						  	/>	
						  	<span v-if='item.section_right'>{{$t('EditTable.num')}}</span>
					  	</div>
					</van-cell>	
				</div>
			</van-cell-group>
			<van-popup v-model="showNum" position="bottom">
				<van-picker
					show-toolbar
					:columns="peopleNum"
					@cancel="showNum = false"
					@confirm='onChangeNum'
				/>
			</van-popup>
			<van-popup v-model="showEndNum" position="bottom">
				<van-picker
					show-toolbar
					:columns="peopleNum"
					@cancel="showEndNum = false"  
					@confirm='onChangeEndNum'
				/>
			</van-popup>
			<!-- <div class='certainBtn' @click='updateBtn()'>{{$t('EditTable.certain')}}</div> -->

			<div class="wrapper">
				<span class="textWrapper">{{$t('EditTable.certain')}}:</span>
				<div class="refresh" @click='updateBtn()'>{{$t('EditTable.certainBtn')}}</div>
			</div>

			<!-- 屏幕链接 -->
			<div class="screenLink">
				<span class="codeText">{{$t('EditTable.screenQRcode')}}</span>
				<van-image
					class="noInput"
					width="100%"
					height="150"
					fit="contain"
					:src="area.screen_qrcode+'?time='+clickTime"      
				/>
				<van-field
					class="noInput"
					readonly
					:label="$t('EditTable.screenLink')"			  	
					type="textarea"
					autosize
					:value='area.screen_link'
				/>  

				<div class="wrapper">
					<span class="textWrapper">{{$t('EditBook.copy')}}:</span>
					<div class="refresh" @click="copy()">{{$t('EditBook.copyBtn')}}</div>
				</div>
				<div class="wrapper">
					<span class="textWrapper">{{$t('EditBook.refresh')}}:</span>
					<div class="refresh" @click="refreshScreenCode()">{{$t('EditBook.refreshBtn')}}</div>
				</div>
				
			</div>
			<!-- 屏幕二维码 -->
			<!-- <div class="screenQRcode">
				<span class="codeText">{{$t('EditTable.screenQRcode')}}</span>
				<van-image
					class="noInput"
					width="100%"
					height="150"
					fit="contain"
					:src="area.screen_qrcode+'?time='+clickTime"      
				/>
				<div class="refresh" @click="refreshScreenCode()">{{$t('EditTable.refresh')}}</div>
			</div> -->
			<!-- 排队二维码区域 -->
			<div class="screenQRcode">
					<span class="codeText">{{$t('EditTable.lineQRcode')}}</span>
					<van-image
						v-if='area.line_qrcode'
						class="noInput"
						width="100%"
						height="150"
						fit="contain"
						:src="area.line_qrcode+'?time='+clickTime"
					/>

					<div class="wrapper">
						<span class="textWrapper">{{$t('EditBook.refresh')}}:</span>
						<div class="refresh" @click='refreshLineCode'>{{$t('EditBook.refreshBtn')}}</div>
					</div>
			</div>
		</div>
		<div v-else class="notify">{{$t('EditBook.text')}}</div>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				areaLists:{},
  				area:{
  					screen_link:'',
  					screen_qrcode:'',
  					line_qrcode:''
  				},
  				showNum:false,
  				showEndNum:false,
  				peopleNum:[
  					'1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20'
  				],
  				section_left:'0',
  				section_right:'0',
  				actIndex:0,
  				clickTime:0,
  				screen:'screen',
  				line:'line',
  				id:'',
				isImgShow:false,
				activeStore:'',
				queue:''
  			}
  		},
  		created(){
  			this.getShop();
			this.getAreaList();
			this.activeStore=sessionStorage.getItem('activeStore');
  		},
  		methods:{
  			getShop(){
    		this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/show',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
					this.queue=res.data.data.line;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('EditShop.message'),
        		});
            });
    	},
    	changeQueue(){
    		var val=this.queue=='1'?'0':'1';
    		this.$axios({
                method: 'PATCH',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/update',
                data:{
                	line:val,
                },
            }).then(res => {
            	 console.log(res);
            	if(res.data.status==200){
                	this.$toast({
	            		type:'success',
	            		message:res.data.message,
	            	});
	            	this.queue=val;
            	}else{
            		this.$toast.allowMultiple();
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('EditShop.message'),
        		});
            });
    	},
  			getAreaList(){
  				this.$axios({
	                method: 'get',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/area',
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.areaLists=res.data.data;
	                	this.area=res.data.area;
	                	this.id=this.areaLists[this.actIndex].id;
	                	// console.log(this.id);
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
            		this.$toast({
	            		type:'fail',
	            		message:this.$t('EditTable.message'),
        			});
            	});
  			},
  			updateNum(){
  				this.$axios({
  					method:'PATCH',
  					headers:{
  						"Authorization": 'Bearer '+sessionStorage.token,
  					},
  					url:this.$build+'/api/area/'+sessionStorage.actShopId+'/update',
  					data:{
  						data:JSON.stringify(this.areaLists)
  					}
  				}).then(res => {
  					console.log(res);
	            	if(res.data.status==200){
	            		this.getAreaList();
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
	            	 }); 
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
  				}).catch(err =>{
  					this.$toast({
	            		type:'fail',
	            		message:this.$t('EditTable.message'),
        			});
  				})
  			},
  			copy() {//复制当剪切板
			    let transfer = document.createElement('input');
			    document.body.appendChild(transfer);
			    transfer.value = this.area.screen_link;  // 这里表示想要复制的内容
			    transfer.focus();
			    transfer.select();
			    if (document.execCommand('copy')) {
			        document.execCommand('copy');
			    }
			    transfer.blur();
			    document.body.removeChild(transfer);
			    this.$toast({
			    	duration:800,
	        		type:'success',
	        		message:this.$t('EditTable.copyScuess'),
	    		});   
			},
	    	onChangeNum(picker, value){
	    		var temp=this.areaLists[this.actIndex];
	    		temp.section_left=picker; 
	    		this.$set(this.areaLists,this.actIndex,temp)
	    		this.showNum=false;
	    		this.section_left=picker;
	    		console.log(this.section_left);
	    		if(this.actIndex>0){
	    			this.areaLists[this.actIndex-1].section_right=Number(picker)-1; //下一个左区间数字加1
	    		}
	    		this.sortOut();
	    	},

	    	onChangeEndNum(picker, value){
	    		var temp=this.areaLists[this.actIndex];
	    		temp.section_right=picker;
	    		this.$set(this.areaLists,this.actIndex,temp)
	    		this.showEndNum=false;
	    		// console.log(this.actIndex);
	    		this.section_right=picker;
	    		if(this.areaLists[this.actIndex+1]){
	    			this.areaLists[this.actIndex+1].section_left=Number(picker)+1; //下一个左区间数字加1
	    		}
	    		this.sortOut();
	    	},
	    	sortOut(){
				for(var i=0;i<this.areaLists.length;i++){
	    			if(i>0){
	    				if(this.areaLists[i].section_left<this.areaLists[i-1].section_right){
		    				this.areaLists[i].section_left=Number(this.areaLists[i-1].section_right)+1;
		    			}
	    			}
	    			if(i<3){
		    			if(this.areaLists[i].section_left>this.areaLists[i].section_right){
		    				this.areaLists[i].section_right=Number(this.areaLists[i].section_left)+1;
		    			}
	    			}
	    		}
	    	},
	    	updateBtn(){
  				this.updateNum();
  			},
  			//刷新二维码
  			refreshQRcode(category){
  				this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/refresh',
	                data:{
	                	category:category
	                }
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
		            	this.clickTime=this.clickTime+1;
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	this.getAreaList();
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('EditTable.message'),
	        		});
	            });
  			},
  			refreshScreenCode(){
  				this.refreshQRcode(this.screen);
  			},
  			refreshLineCode(){
  				this.refreshQRcode(this.line);
  			}
  		}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color: #2f75f7;
	}
	.contentGroup{
		/* padding-top: 46px; */
	}
	#home{
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		background: #f3f5f7;
	}
	.van-cell{
		border-bottom: 1px solid #eee;
	}
	.refresh,.certainBtn{
		width: 120px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		border-radius: 15px;
		background: #2f75f7;
		color: #fff;
		margin: 10px auto;
		margin-right: 10px;
	}
	.certainBtn{
		display: flex;
		justify-content: center;
	}
	.inputNum{
		padding: 0;
		width: 15%;
		margin-left: 16%;
		border:none;
	}
	.inputEndNum{
		margin-left: 7px;
	}
	.inputWrap{
		display: flex;		
	}
	.text{
		font-size: 16px;
	}
	.codeText{
		padding-left: 16px;
	}
	/* 屏幕链接区域 */
	.screenLink{
		background: #fff;
		margin: 10px 0;
		border-bottom: 1px solid #eee;
	}
	/* 屏幕二维码区域 排队二维码区域 */
	.screenQRcode{
		background: #fff;
		height: 230px;
		margin-bottom: 35px;
		border-bottom: 1px solid #eee;
	}

	.notify{
		text-align: center;
		font-size: 20px;
		margin-top: 60px;
	}
	.wrapper{
		display: flex;
		padding: 0 16px;
	}
	.textWrapper{
		line-height: 50px;
	}
</style>


// WEBPACK FOOTER //
// src/Shop/EditTable.vue